import styles from '@ui/components/Select/Select.module.scss';
import SelectItems from '@ui/components/Select/components/SelectItems';
import Checkbox from '@ui/components/Checkbox/Checkbox';
import SelectItemIcon from '@ui/components/Select/components/SelectItemIcon';
import React, { forwardRef } from 'react';
import classNames from 'classnames';
import {
  Select as BaseSelect,
  SelectLabel,
  SelectItem,
  SelectItemCheck,
  SelectPopover,
  SelectProvider,
} from '@ariakit/react';

const SelectRegular = forwardRef(
  (
    {
      store,
      hasOutline,
      items,
      label,
      name,
      className,
      placeholder,
      required,
      multiple,
    },
    ref,
  ) => {
    const { mounted, open, value } = store.useState();
    const hasIcons = items.every(i => i.icon);
    const selectedItem = multiple
      ? value
      : items.find(item => item.value === value);

    return (
      <div
        className={classNames(
          styles.container,
          className,
          'piwik_standard_dropdown',
        )}
      >
        <SelectProvider animated store={store}>
          <SelectLabel className={styles.label}>{label}</SelectLabel>
          <BaseSelect
            className={classNames(styles.select, {
              [styles.outline]: hasOutline,
            })}
            name={name}
            ref={ref}
            required={required}
          >
            <SelectItems
              hasIcons={hasIcons}
              hasOutline={hasOutline}
              items={items}
              mounted={mounted}
              multiple={multiple}
              open={open}
              placeholder={placeholder}
              selectedItem={selectedItem}
            />
          </BaseSelect>
          <SelectPopover
            className={classNames(styles.popover, {
              [styles.outline]: hasOutline,
            })}
            gutter={0}
            portal
            sameWidth
            unmountOnHide
          >
            {items.map(item => (
              <SelectItem
                className={classNames(styles.selectItem, {
                  [styles.outline]: hasOutline,
                })}
                hideOnClick={!multiple}
                key={`${item.label}${item.value}`}
                value={item.value}
              >
                {multiple ? (
                  <SelectItemCheck
                    render={
                      <Checkbox
                        align="center"
                        checked={selectedItem.find(
                          selected => item.value === selected,
                        )}
                        noMargin
                        variant="circle"
                      />
                    }
                  />
                ) : (
                  hasIcons &&
                  item?.icon && (
                    <SelectItemIcon
                      isImage={item.icon.includes('/')}
                      src={item.icon}
                    />
                  )
                )}
                {item.label}
              </SelectItem>
            ))}
          </SelectPopover>
        </SelectProvider>
      </div>
    );
  },
);

SelectRegular.displayName = 'SelectRegular';

export default SelectRegular;
